import moment from 'moment';
import $http from '@/http.js';
import router from '../../../router';

const state = {
  productsQuantity: 0,
  productsTotal: 0,
  paymentOption: '',
  deliveryOption: 1,
  buyerData: {},
  cart: {},
  body: {},
  postOrder: {},
  ticketUrl: '',
  orderData: null,
  selectedSeat: null,
  removedSeat: null,
  printTickets: false,
  canceledSeat: null,
  orderTickets: null,
  nominationStartDate: null,
  namedOrder: false,
  buyerDataCommissary: null,
  orderPdvData: null,
  productsOrder: null,
  totalValueOrder: 0,
  pendingOrder: false,
  deliveryObject: null,
  hoverShape: null,
  firstPayment: false,
  createOrderInProgress: false,
  showPreSale: false,
  validatedPreSale: false,
  couponPreSale: null,
  screenTimeOn: 0,
  timeToViewProducts: null,
  cartAbandoned: null,
  removeScheduledCampaigns: false,
};

const mutations = {
  INCREMENT_PRODUCTS_QUANTITY(state) {
    state.productsQuantity++;
  },
  SET_PRODUCTS_ORDER(state, value) {
    state.productsOrder = value;
  },
  SET_NAMED_ORDER(state, value) {
    state.namedOrder = value;
  },
  SET_VALIDATED_PRE_SALE(state, value) {
    state.validatedPreSale = value;
  },
  SET_COUPON_PRE_SALE(state, value) {
    state.couponPreSale = value;
  },
  SET_REMOVE_SCHEDULED_CAMPAIGNS(state, value) {
    state.removeScheduledCampaigns = value;
  },
  SET_SHOW_PRE_SALE(state, value) {
    state.showPreSale = value;
  },
  SET_HOVER_SHAPE(state, value) {
    state.hoverShape = value;
  },
  DECREMENT_PRODUCTS_QUANTITY(state) {
    if (state.productsQuantity > 0) {
      state.productsQuantity--;
    }
    if (state.productsQuantity < 0) state.productsQuantity = 0;
  },
  CLEAR_PRODUCTS_QUANTITY(state) {
    state.productsQuantity = 0;
  },
  SET_PRODUCTS_QUANTITY(state, productsQuantity) {
    state.productsQuantity = productsQuantity;
  },
  INCREMENT_PRODUCTS_TOTAL(state, product) {
    if (router.history.current.name === 'commissioner')
      state.productsTotal +=
        Number(product.valor) + Number(product.valor_conveniencia);
    else state.productsTotal += product.valor + product.valor_conveniencia;
  },
  DECREMENT_PRODUCTS_TOTAL(state, product) {
    state.productsTotal -= product.valor + product.valor_conveniencia;
  },
  SET_PRODUCTS_TOTAL(state, productsTotal) {
    state.productsTotal = productsTotal;
  },
  SET_TOTAL_VALUE_ORDER(state, totalValueOrder) {
    state.totalValueOrder = totalValueOrder;
  },
  CLEAR_PRODUCTS_TOTAL(state) {
    state.productsTotal = 0;
  },
  SET_REMOVED_SEAT(state, removedSeat) {
    state.removedSeat = removedSeat;
  },
  SET_CANCELED_SEAT(state, canceledSeat) {
    state.canceledSeat = canceledSeat;
  },
  SET_PAYMENT_OPTION(state, option) {
    state.paymentOption = option;
  },
  SET_SCREEN_TIME_ON(state, option) {
    state.screenTimeOn = option;
  },
  SET_DELIVERY_OPTION(state, option) {
    state.deliveryOption = option;
  },
  SET_BUYER_DATA(state, buyerData) {
    state.buyerData = buyerData;
  },
  SET_BODY(state, body) {
    state.body = body;
  },
  SET_POST_ORDER(state, postOrder) {
    state.postOrder = postOrder;
  },
  SET_PAYMENT(state, payment) {
    state.payment = payment;
  },
  SET_CONFIRMATION_CART(state, cart) {
    state.cart = cart;
  },
  SET_BUYER_DATA_COMMISSARY(state, value) {
    state.buyerDataCommissary = value;
  },
  SET_TICKET_URL(state, ticketUrl) {
    state.ticketUrl = ticketUrl;
  },
  SET_ORDER_DATA(state, orderData) {
    state.orderData = orderData;
  },
  SET_ORDER_PDV(state, order) {
    state.orderPdvData = order;
  },
  SET_TIME_TO_VIEW_PRODUCTS(state, data) {
    state.timeToViewProducts = data;
  },
  SET_PRINT_TICKETS(state, printTickets) {
    state.printTickets = printTickets;
  },
  SET_SELECTED_SEAT(state, selectedSeat) {
    state.selectedSeat = selectedSeat;
  },
  SET_ORDER_TICKETS(state, orderTickets) {
    state.orderTickets = orderTickets;
  },
  SET_NOMINATION_START_DATE(state, date) {
    state.nominationStartDate = date;
  },
  SET_PENDING_ORDER(state, pendingOrder) {
    state.pendingOrder = pendingOrder;
  },
  SET_FIRST_PAYMENT(state) {
    state.firstPayment = true;
  },
  SET_DELIVERY_OPTION_OBJECT(state, deliveryObject) {
    state.deliveryObject = deliveryObject;
  },
  SET_CREATE_ORDER_IN_PROGRESS(state, data) {
    state.createOrderInProgress = data;
  },
  SET_CART_ABANDONED(state, data) {
    state.cartAbandoned = data;
  },
};

const actions = {
  incrementProductsQuantity: ({ commit }, product) => {
    commit('INCREMENT_PRODUCTS_QUANTITY');
    commit('INCREMENT_PRODUCTS_TOTAL', product);
  },
  decrementProductsQuantity: ({ commit }, product) => {
    commit('DECREMENT_PRODUCTS_QUANTITY');
    commit('DECREMENT_PRODUCTS_TOTAL', product);
  },
  setPaymentOption: ({ commit }, option) => {
    commit('SET_PAYMENT_OPTION', option);
  },
  setDeliveryOption: ({ commit, dispatch, getters }, option) => {
    const eventState = {
      id: getters.eventID,
      deliveryOption: option,
    };
    dispatch('saveCheckoutState', eventState);

    commit('SET_DELIVERY_OPTION', option);
  },
  setDeliveryOptionObject: ({ commit, dispatch, getters }, option) => {
    commit('SET_DELIVERY_OPTION_OBJECT', option);
  },
  loadDeliveryOption: ({ commit, dispatch }, option) => {
    // dispatch('nextStep')
    commit('SET_DELIVERY_OPTION', option);
  },
  loadProductsQuantity: ({ commit }, productsQuantity) => {
    commit('SET_PRODUCTS_QUANTITY', productsQuantity);
  },
  loadProductsTotal: ({ commit }, productsTotal) => {
    commit('SET_PRODUCTS_TOTAL', productsTotal);
  },
  setBuyerData: ({ commit }, buyerData) => {
    commit('SET_BUYER_DATA', buyerData);
  },
  setCanceledSeat: ({ commit }, canceledSeat) => {
    commit('SET_CANCELED_SEAT', canceledSeat);
  },
  unbookPurchaseSeats: async ({ dispatch }, seatCode) => {
    try {
      dispatch('addLoading');
      const response = await $http.delete(
        `/v2/events/seats/book?seat_id=${seatCode}`
      );
      dispatch('subtractLoading');
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  setSelectedSeat: async ({ getters, commit, dispatch }, selectedSeat) => {
    if (!selectedSeat.op) {
      try {
        dispatch('addLoading');
        const response = await $http.delete(
          `/v2/events/seats/book?seat_id=${selectedSeat.codigo_assento}`
        );
        dispatch('subtractLoading');
        commit('SET_SELECTED_SEAT', null);
        return response.data;
      } catch (error) {
        throw error;
      }
    } else {
      try {
        dispatch('addLoading');
        const response = await $http.post(
          `/v2/events/seats/book?seat_id=${selectedSeat.codigo_assento}&coupon=${getters.cupomCode}`
        );
        dispatch('subtractLoading');
        commit('SET_SELECTED_SEAT', selectedSeat);
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  },
  saveBuyerData: ({ dispatch, getters }) => {
    var buyer;
    buyer = {
      codigo_evento: getters.body.codigo_evento,
      codigo_pedido: getters.body.codigo_pedido,
      email: getters.userProps.email,
      telefone: getters.userProps.phone,
      nome: getters.userProps.name,
      documento: getters.userProps.document,
    };

    $http
      .post('pdv/orders/register-guest-buyer', buyer)
      .then(response => {
        dispatch('setBuyerData', {});
      })
      .catch(err => {
        console.error(`Failed saving buyder data`, err);
      });
  },
  setBody: ({ commit }, body) => {
    commit('SET_BODY', body);
  },
  setRemovedSeat: ({ commit }, removedSeat) => {
    commit('SET_REMOVED_SEAT', removedSeat);
  },
  setPostOrder: ({ commit }, postOrder) => {
    commit('SET_POST_ORDER', postOrder);
  },
  setCreationCart: ({ dispatch, commit, getters }, cartProducts) => {
    commit('SET_CREATE_ORDER_IN_PROGRESS', true);
    const order = { body: [] };

    cartProducts.forEach(product => {
      product.forEach(tipo => {
        order.body.push({
          cupom: getters.cupomCode,
          event: tipo.codigo_evento,
          product: tipo.codigo_produto,
          type: tipo.codigo_tipo,
          qtd: tipo.quantidade,
          qtdade_min: tipo.qts_min,
          lot: tipo.lote,
          amount: tipo.valor,
          pay_option: 'P',
          seats: tipo.seats ? [...new Set(tipo.seats)] : '',
          ticket_id: getters.ticketCodeUrl
            ? Number(getters.ticketCodeUrl)
            : null,
        });
      });
    });
    if (getters.facebookFbcFbp && getters.facebookFbcFbp.fbp)
      order.fbp = getters.facebookFbcFbp.fbp;
    if (getters.facebookFbcFbp && getters.facebookFbcFbp.fbc)
      order.fbc = getters.facebookFbcFbp.fbc;
    const event = order.body.map(v => v.event);
    const ht = localStorage.getItem('ht');
    let count = localStorage.getItem(`count-create-${getters.eventID}`);
    if (!count) {
      localStorage.setItem(`count-create-${getters.eventID}`, 1);
      count = 1;
    } else {
      count = Number(count) + 1;
      localStorage.setItem(`count-create-${getters.eventID}`, count);
    }

    if (getters.cartAbandoned) order.carrinho_abandonado = true;

    if (getters.timeToViewProducts) order.dac = getters.timeToViewProducts;

    if (getters.ticketCodeUrl) order.ticket_id = Number(getters.ticketCodeUrl);

    order.tep = getters.screenTimeOn;

    dispatch('setPurchaseStarted', true);
    dispatch('addLoading');
    return $http
      .post(`pdv/orders/create?check=${ht}-${count}`, order, {
        headers: { TERMINAL: ht },
      })
      .then(response => {
        const confirmacao = response.data;
        if (confirmacao.status === 'A') {
          commit('SET_PARTIAL_VALUE', Number(confirmacao.valor_total));
          commit('SET_ORDER_TICKETS', confirmacao.ingressos);
          localStorage.setItem(
            'ORDER_TICKETS',
            JSON.stringify(confirmacao.ingressos)
          );
          commit(
            'SET_NOMINATION_START_DATE',
            confirmacao.evento.data_nomeacao_ingresso
          );
          const body = {
            codigo_pedido: confirmacao.codigo_pedido,
            codigo_evento: confirmacao.codigo_evento,
            codigo_apresentacao: confirmacao.codigo_evento,
            parcelas: getters.instalmentAmount,
            pdv: confirmacao.pdv,
            pos: confirmacao.pos,
            forma_pagamento: confirmacao.forma_pagamento,
            op: 'venda',
            expiration:
              confirmacao.data * 1000 +
              (confirmacao.segundos_expiracao_pedido / 60) * 60 * 1000,
            hash_pedido: confirmacao.hash_pedido,
            cupom: confirmacao.cupom,
          };
          dispatch('setBody', body);
          dispatch('setConfirmationCart', cartProducts);
          const eventState = {
            id: confirmacao.codigo_evento,
            body,
            cartProducts,
            productsQuantity: getters.productsQuantity,
            productsTotal: getters.productsTotal,
            step: 1,
          };
          dispatch('saveCheckoutState', eventState);
          dispatch('subtractLoading');
          console.log('setPurchaseStarted - setCreationCart 250 - false');
          dispatch('setPurchaseStarted', false);
          commit('SET_SECTOR_MAP', null);
          commit('SET_SELECTED_SEAT', null);
          commit('SET_SHOW_DEFAULT', true);
        }
        dispatch('subtractLoading');

        return response;
      })
      .catch(err => {
        dispatch('subtractLoading');
        console.log('setPurchaseStarted - setCreationCart 260 - false');
        dispatch('setPurchaseStarted', false);
        if (err && err.response && err.response.status === 429)
          dispatch('openSnackbar', {
            message: err.response.data.message,
          });
        console.error(`Failed creating order for the event ${event}`, err);
      });
  },

  setConfirmationCart: ({ commit, dispatch }, cartProducts) => {
    const cart = [];

    cartProducts.forEach(product => {
      product.forEach(tipo => {
        cart.push({
          product: tipo.codigo_produto,
          type: tipo.codigo_tipo,
          name: tipo.nome_tipo_pos,
          qtd: tipo.quantidade,
          price: `R$ ${tipo.valor}`,
          raw_price: tipo.valor,
          convenience: tipo.valor_conveniencia,
          lot: tipo.lote,
          total: `R$ ${tipo.valor + tipo.valor_conveniencia}`,
        });
      });
    });

    dispatch('nextStep');
    commit('SET_CONFIRMATION_CART', cart);
  },

  confirmOrder: ({ state, getters, commit, dispatch }, totemCredit) => {
    // Setting Customer Email and Name when ticket is free and named
    // let name = ''
    // let email = ''
    // if ((!getters.userProps.email || !getters.userProps.name) && getters.productsTotal === 0) {
    //   let event = JSON.parse(localStorage.getItem('eventID'))
    //   let checkoutState = JSON.parse(localStorage.getItem('checkoutState'))[event]
    //   if (checkoutState.namedTickets && checkoutState.namedTickets[0] && checkoutState.namedTickets[0].dados_extras) {
    //     let extradata = checkoutState.namedTickets[0].dados_extras
    //     email = extradata.find(e => e.tipo === 'email').valor
    //     name = extradata.find(e => e.tipo === 'nome').valor
    //   }
    // }

    const params = {
      body: {
        ...state.body,
        forma_pagamento: getters.paymentOption,
      },
      payment: state.paymentOption,
      delivery_option_id: getters.deliveryOption,
      cart: getters.cart,
      customer_name: getters.userProps.name,
      customer_email: getters.userProps.email,
      customer_phone: getters.userProps.phone,
      customer_doc: getters.userProps.document,
      customer_address: getters.userProps.address,
      customer_address_number: getters.userProps.number,
      customer_address_complement: getters.userProps.complement,
      customer_zipcode: getters.userProps.cep,
      customer_neighborhood: getters.userProps.neighborhood,
      customer_city: getters.userProps.city,
      customer_state: getters.userProps.state,
      customer_country: getters.userProps.country,
    };

    if (getters.buyerData.email) {
      params.email = getters.buyerData.email;
    }

    if (getters.buyerData.clientID) {
      params.user_id = getters.buyerData.clientID;
    }

    dispatch('addLoading');
    return $http
      .post('pdv/orders/confirm', params)
      .then(response => {
        const { data } = response;

        if (data.success) {
          commit('SET_ORDER_DATA', data);
          commit('SET_TICKET_URL', data.ticketsUrl);
          const postOrder = {
            ...getters.postOrder,
            // email: getters.buyerData.email,
            // phone: `${getters.buyerData.ddd}${getters.buyerData.phone}`,
            status: 'Aprovado',
            payment: state.paymentOption,
          };

          if (getters.buyerData.email) {
            postOrder.email = getters.buyerData.email;
          }

          if (getters.buyerData.phone) {
            postOrder.phone = `${getters.buyerData.ddd}${getters.buyerData.phone}`;
          }

          if (getters.buyerData.clientID) {
            postOrder.user_id = getters.buyerData.clientID;
          }

          commit('SET_POST_ORDER', postOrder);

          dispatch('setBody', {
            ...getters.body,
            expiration: 0,
          });
          // if (!getters.buyerData.clientID) {
          //   dispatch('saveBuyerData');
          // } else {
          //   dispatch('setBuyerData', {});
          // }
        }

        if (getters.postOrder && !getters.postOrder.organizador) {
          dispatch('setPostOrder', {
            ...getters.postOrder,
            organizador: data.orderData.nome_organizador,
            cpf_organizador: data.orderData.org_cpf,
            cnpj_organizador: data.orderData.org_cnpj,
            mensagem: data.orderData.mensagem_conclusao_pedido,
          });
        }

        dispatch('subtractLoading');
        if (!totemCredit) dispatch('nextStep');
        return response.data;
      })
      .catch(err => {
        dispatch('subtractLoading');
        console.error(`Failed confirming order`, err);
      });
  },
  clearCartData: ({ commit, dispatch }) => {
    commit('SET_PRODUCTS_QUANTITY', 0);
    commit('SET_PRODUCTS_TOTAL', 0);
    commit('SET_CONFIRMATION_CART', {});
    console.log('setPurchaseStarted - clearCartData - false');
    dispatch('setPurchaseStarted', false);
  },
  saveUserProps: async ({ commit, dispatch }, userData) => {
    try {
      dispatch('addLoading');
      const response = await $http.post(`clients/register`, userData);
      dispatch('subtractLoading');
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getOrderDetails: async ({ commit, dispatch, getters }, hash) => {
    try {
      dispatch('addLoading');
      const response = await $http.get(`orders/continue?hash=${hash}`);
      localStorage.removeItem('userProps');
      const confirmacao = response.data;
      commit('SET_BUYER_DATA_COMMISSARY', confirmacao.dados_comprador);
      if (confirmacao.valor_pago === Number(confirmacao.valor_total)) {
        if (process.env.NODE_ENV === 'development')
          window.open(
            `https://site.dev.btservers.com.br/ingressos/${hash}`,
            '_self'
          );
        else if (process.env.NODE_ENV === 'production')
          window.open(
            `https://site.blueticket.com.br/ingressos/${hash}`,
            '_self'
          );
        else
          window.open(
            `https://site.homolog.btservers.com.br/ingressos/${hash}`,
            '_self'
          );
      }
      if (confirmacao.cupom) commit('SET_CUPOM_CODE', confirmacao.cupom);
      if (Number(confirmacao.valor_total) > confirmacao.valor_pago) {
        if (!confirmacao.valor_pago) commit('SET_FIRST_PAYMENT');
        commit('SET_PENDING_ORDER', true);
        commit('SET_PARTIAL_VALUE', Number(confirmacao.valor_pendente));
      }
      if (confirmacao.cupom) commit('SET_CUPOM_CODE', confirmacao.cupom);
      commit('SET_TOTAL_VALUE_ORDER', Number(confirmacao.valor_total));
      commit('SET_ORDER_PDV', confirmacao);
      commit('SET_PRODUCTS_ORDER', confirmacao.produtos_array);
      commit('SET_EVENT_PDV', confirmacao.pdv);
      commit('SET_EVENT_POS', confirmacao.pos);
      await dispatch('setEventID', confirmacao.codigo_evento);
      // await dispatch('fetchEventData')
      // await dispatch('setSectorsList')
      dispatch('setSkeleton', false);
      let named = false;
      response.data.ingressos.forEach(product => {
        dispatch('incrementProductsQuantity', product);
        if (
          product.dados_extras &&
          product.dados_extras[0] &&
          product.dados_extras[0].valor
        )
          named = true;
      });
      if (named) {
        dispatch('setCurrentStep', 3);
        commit('SET_NAMED_ORDER', true);
      }
      commit('SET_ORDER_TICKETS', confirmacao.ingressos);
      localStorage.setItem(
        'ORDER_TICKETS',
        JSON.stringify(confirmacao.ingressos)
      );
      commit(
        'SET_NOMINATION_START_DATE',
        confirmacao.evento.data_nomeacao_ingresso
      );
      const body = {
        codigo_pedido: confirmacao.codigo_pedido || confirmacao.codigo,
        codigo_evento: confirmacao.codigo_evento,
        codigo_apresentacao: confirmacao.codigo_evento,
        parcelas: getters.instalmentAmount ? getters.instalmentAmount : null,
        pdv: confirmacao.pdv,
        pos: confirmacao.pos,
        forma_pagamento: confirmacao.forma_pagamento,
        op: 'venda',
        // expiration: confirmacao.data * 1000 + (confirmacao.segundos_expiracao_pedido / 60) * 60 * 1000,
        hash_pedido: confirmacao.hash_pedido,
        cupom: confirmacao.cupom,
      };
      dispatch('setBody', body);
      dispatch('setConfirmationCart', getters.cartProducts);
      const eventState = {
        id: confirmacao.codigo_evento,
        body,
        cartProducts: getters.cartProducts,
        productsQuantity: getters.productsQuantity,
        productsTotal: getters.productsTotal,
        step: 1,
      };
      dispatch('saveCheckoutState', eventState);
      dispatch('subtractLoading');
      console.log('setPurchaseStarted - setCreationCart 250 - false');
      dispatch('setPurchaseStarted', false);
      commit('SET_SECTOR_MAP', null);
      commit('SET_SELECTED_SEAT', null);
      commit('SET_SHOW_DEFAULT', true);
      dispatch('subtractLoading');
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  refreshExpirationTime({ commit, dispatch }, eventStateID) {
    const checkoutState =
      JSON.parse(localStorage.getItem(`checkoutState`)) || false;
    if (checkoutState) {
      const eventState = checkoutState[eventStateID] || false;
      if (eventState) {
        const { body } = eventState;
        const currentTimestamp = moment().unix();
        body.expiration = currentTimestamp * 1000 + 15 * 60 * 1000;

        dispatch('setBody', body);

        eventState.body = body;

        dispatch('saveCheckoutState', eventState);
      }
    }
  },
  async saveNamedTicket({ dispatch, commit, getters, state }, tickets) {
    let payload = tickets
      .filter(ticket => ticket.dados_extras)
      .map(async t => {
        let pm = new Promise((resolve, reject) => {
          Promise.all(
            t.dados_extras.map(async de => {
              if (de.tipo === 'secao') de.valor = de.titulo;
              if (de.tipo === 'upload_arquivo' || de.tipo === 'upload_imagem') {
                if (de.tipo === 'upload_arquivo') {
                  let params = new FormData();
                  params.append('image', de.file);
                  params.append('event_id', tickets[0].codigo_evento);
                  params.append('ticket_id', tickets.ticket);

                  return $http({
                    method: 'post',
                    url: '/v2/tickets/assign/upload',
                    data: params,
                    headers: { 'Content-Type': 'multipart/form-data' },
                  }).then(function(response) {
                    de.valor = response.data.url;
                    return {
                      codigo: de.codigo,
                      valor: de.valor,
                    };
                  });
                }
                if (de.tipo === 'upload_imagem') {
                  let params = new FormData();
                  params.append('image', de.image);
                  params.append('event_id', tickets[0].codigo_evento);
                  params.append('ticket_id', tickets.ticket);

                  return $http({
                    method: 'post',
                    url: '/v2/tickets/assign/upload',
                    data: params,
                    headers: { 'Content-Type': 'multipart/form-data' },
                  }).then(function(response) {
                    de.valor = response.data.url;
                    return {
                      codigo: de.codigo,
                      valor: de.valor,
                    };
                  });
                }
              } else {
                return {
                  codigo: de.codigo,
                  valor: de.valor,
                };
              }
            })
          ).then(resp => {
            resolve(resp);
          });
        });
        return pm.then(function(e) {
          return {
            ticket_id: t.codigo || t.codigo_barras,
            extradata: e,
          };
        });
      });
    return Promise.all(payload).then(async values => {
      let result = {
        tickets: JSON.parse(JSON.stringify(values)),
        order_hash:
          router.history.current.name !== 'commissioner'
            ? getters.body.hash_pedido
            : getters.orderPdvData.hash_pedido,
      };
      let next = false;
      await $http
        .post(
          `orders/tickets/assign/${
            tickets[0].codigo_evento
              ? tickets[0].codigo_evento
              : getters.eventID
          }`,
          result
        )
        .then(resp => {
          if (resp.status === 200) next = true;
        });
      let checkoutState = JSON.parse(localStorage.getItem('checkoutState'));

      if (checkoutState && checkoutState[tickets[0]]) {
        localStorage.setItem(
          'checkoutState',
          JSON.stringify({
            ...checkoutState,
            [tickets[0].codigo_evento]: {
              ...checkoutState[tickets[0].codigo_evento],
              namedTickets: tickets,
            },
          })
        );
      } else {
        localStorage.setItem(
          'checkoutState',
          JSON.stringify({
            ...checkoutState,
            [tickets[0].codigo_evento]: {
              namedTickets: tickets,
            },
          })
        );
      }

      if (tickets[0] && tickets[0].dados_extras) {
        const emailObj = tickets[0].dados_extras.find(
          de => de.tipo === 'email'
        );
        const nameObj = tickets[0].dados_extras.find(de => de.tipo === 'nome');
        let userProps = {
          selectedDocument: '',
          emailConfirmation: '',
          email: emailObj.valor,
          document: '',
          name: nameObj.valor,
          phone: '',
        };

        let newUserProps = JSON.parse(JSON.stringify(userProps));

        const localUserProps = JSON.parse(localStorage.getItem('userProps'));
        if (localUserProps) {
          newUserProps = {
            ...userProps,
            ...localUserProps,
            email: localUserProps.email || userProps.email,
            name: localUserProps.name || userProps.name,
          };
        }
        await dispatch('setUserProps', newUserProps);
        if (
          getters.productsTotal === 0 &&
          router.history.current.name !== 'commissioner'
        ) {
          await dispatch('setPaymentOption', 'D');
          await dispatch('confirmOrder');
          await dispatch('setPostOrder', {
            ...this.getters.postOrder,
            email: emailObj.valor,
          });
          dispatch('setSignSteps', { logged: true, signForm: false, step: 0 });
          if (next) {
            dispatch('nextStep');
            dispatch('nextStep');
          } else
            dispatch('openSnackbar', {
              message:
                'Não foi possível concluir sua compra no momento. Tente novamente',
            });
          localStorage.setItem('iframePurcheased', true);
        } else {
          if (next) dispatch('nextStep');
          else
            dispatch('openSnackbar', {
              message:
                'Não foi possível concluir sua compra no momento. Tente novamente',
            });
        }
      }
    });
  },
};

const getters = {
  hoverShape(state) {
    return state.hoverShape;
  },
  couponPreSale(state) {
    return state.couponPreSale;
  },
  productsQuantity(state) {
    return state.productsQuantity;
  },
  showPreSale(state) {
    return state.showPreSale;
  },
  firstPayment(state) {
    return state.firstPayment;
  },
  productsOrder(state) {
    return state.productsOrder;
  },
  orderData(state) {
    return state.orderData;
  },
  printTickets(state) {
    return state.printTickets;
  },
  productsTotal(state) {
    return state.productsTotal;
  },
  totalValueOrder(state) {
    return state.totalValueOrder;
  },
  paymentOption(state) {
    return state.paymentOption;
  },
  deliveryOption(state) {
    return state.deliveryOption;
  },
  buyerData(state) {
    return state.buyerData;
  },
  screenTimeOn(state) {
    return state.screenTimeOn;
  },
  validatedPreSale(state) {
    return state.validatedPreSale;
  },
  timeToViewProducts(state) {
    return state.timeToViewProducts;
  },
  cart(state) {
    return state.cart;
  },
  body(state) {
    return state.body;
  },
  cartAbandoned(state) {
    return state.cartAbandoned;
  },
  namedOrder(state) {
    return state.namedOrder;
  },
  postOrder(state) {
    return state.postOrder;
  },
  ticketUrl(state) {
    return state.ticketUrl;
  },
  buyerDataCommissary(state) {
    return state.buyerDataCommissary;
  },
  orderPdvData(state) {
    return state.orderPdvData;
  },
  selectedSeat(state) {
    return state.selectedSeat;
  },
  removedSeat(state) {
    return state.removedSeat;
  },
  canceledSeat(state) {
    return state.canceledSeat;
  },
  pendingOrder(state) {
    return state.pendingOrder;
  },
  deliveryObject(state) {
    return state.deliveryObject;
  },
  orderTickets(state) {
    if (state.orderTickets) return state.orderTickets;
    else {
      const event = JSON.parse(localStorage.getItem('eventID'));
      return JSON.parse(localStorage.getItem('checkoutState'))[event]
        .namedTickets;
    }
  },
  nominationStartDate(state) {
    return state.nominationStartDate;
  },
  createOrderInProgress(state) {
    return state.createOrderInProgress;
  },
  removeScheduledCampaigns(state) {
    return state.removeScheduledCampaigns;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
